import React from 'react'
import { Button,  Modal } from 'semantic-ui-react'

function Help() {
  const [open, setOpen] = React.useState(false)

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button style = {{ background : "grey"}}>Help</Button>}
    >
      <Modal.Header>How to play WhoAmAi?</Modal.Header>
      <Modal.Content image>
        {/* <Image size='medium' src='https://react.semantic-ui.com/images/avatar/large/rachel.png' wrapped /> */}
        <Modal.Description>
        <div>
          <p style = {{ background : "grey"}}>
          You are about to participate in discussion with other players. You can choose to post your message in the chat playing an Artificial Agent or a human by clicking on the relative send button. The other players can do the same. There is, however, an actual Artificial Intelligence Agent, and the main goal is to find it. You can click on the buttons near the messages to guess if it is or not an AI. If it was a true AI and you clicked yes, you get 10 points. If another player played an AI role, you get 1 point and -1 point if the part was human. You also add penalties to other players who don't guess your message, so it is worth posting messages in the chat. A leaderboard lists the top players so far, and you can be one of them. Have fun and be polite, of course. 
          </p>
          </div>
          
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        {/* <Button color='black' onClick={() => setOpen(false)}>
          Nope
        </Button> */}
        <Button
          content="Yep, I got it"
          labelPosition='right'
          icon='checkmark'
          onClick={() => setOpen(false)}
          positive
        />
      </Modal.Actions>
    </Modal>
  )
}

export default Help